import React from "react";
import { FiBell } from "react-icons/fi";

/**
 * Notifications Button Component
 * Displays notification bell with indicator
 */
const NotificationButton = () => {
  return (
    <button className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors">
      <FiBell className="text-xl text-gray-600" />
      <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
    </button>
  );
};

export default NotificationButton;
